<!-- 一键登录 -->
<template>
  <div class="phonelogin">
    <close />
    <div class="phoneloginLogo">
      <img src="@/assets/img/registrationLogin/phonelogin.png" alt />
    </div>
    <div class="getPhoneMain">
      <div class="getPhone">{{ getPhoneNum }}</div>
      <div class="phoneDescribe fontWeightCom">认证服务由中国移动提供</div>
    </div>
    <sendButton buttonText="本机号码一键登录" :getPhoneNum="getPhoneNum" />
    <div class="otherPhonelogin fontWeightCom">其他手机号码登录</div>
    <termsAgreement />
  </div>
</template>

<script>
import close from '@/components/login/close.vue';
import sendButton from '@/components/login/sendButton.vue';
import termsAgreement from '@/components/login/termsAgreement.vue';

export default {
  components: {
    close,
    sendButton,
    termsAgreement,
  },
  data() {
    return {
      getPhoneNum: '13833338888',
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    const $this = this;
    const { getPhoneNum } = $this;

    $this.getPhoneNum = getPhoneNum.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
  },
  mounted() {
    document.getElementsByClassName('app')[0].setAttribute('style', 'background-color:#fff');
  },
  beforeDestroy() {
    document.getElementsByClassName('app')[0].removeAttribute('style');
  },
};
</script>
<style lang="scss" scoped>
.fontWeightCom {
  font-weight: 400;
}

.phonelogin {
  width: 100%;
  background-color: #fff;

  .phoneloginLogo {
    padding-top: 49px;
    text-align: center;
    img {
      width: 181px;
      height: 181px;
    }
  }

  .getPhoneMain {
    margin: 143px 0 125px 0;
    text-align: center;
    .getPhone {
      padding-bottom: 14px;
      color: #333;
      font-weight: 500;
      font-size: 51px;
      line-height: 72px;
      letter-spacing: 2px;
    }

    .phoneDescribe {
      color: #a5a5a5;
      font-size: 25px;
      line-height: 36px;
    }
  }

  .otherPhonelogin {
    padding-top: 47px;
    color: #a5a5a5;
    font-size: 25px;
    line-height: 36px;
    text-align: center;
  }
}
</style>
